// extracted by mini-css-extract-plugin
export default {"container":"alt-button__container___1nlzx","icon":"alt-button__icon___SH834"};